import { REQUEST_MAPPING } from "@/common/constant";
import REQUEST from "@/common/api.service";

export const CREATE_USER = (params) =>
  REQUEST.post(REQUEST_MAPPING.COMPANY + "/user", params);

export const EDIT_USER = (params) =>
  REQUEST.put(REQUEST_MAPPING.COMPANY + "/user", params);

export const SEND_MAIL_RESET_PASSWORD = (params) =>
  REQUEST.post(REQUEST_MAPPING.USER + "/send-mail-reset-pass", params);

export const RESET_PASSWORD = (params) =>
  REQUEST.post(REQUEST_MAPPING.USER + "/change-password-forgot", params);

export const CHECK_TOKEN_RESET_PASS_IS_EXPIRED = (params) =>
  REQUEST.post(REQUEST_MAPPING.USER + "/check-token-reset-pass", params);


export const RESET_PASSWORD_FORGOT = (params) =>
  REQUEST.post(REQUEST_MAPPING.USER + "/change-password-forgot", params);

export const CHECK_TOKEN_RESET_PASS_FORGOT_IS_EXPIRED = (params) =>
  REQUEST.post(REQUEST_MAPPING.USER + "/check-token-forgot-pass", params);
